import {useEffect, useState} from "react"
import {makeStyles} from '@material-ui/core/styles';
import {Box, Grid} from '@material-ui/core';
import clsx from 'clsx';
import {CREATOR_REELS_TABLE_SUBHEADER, REELS_TABLE_HEADER} from '../../../../../config/mock';
import {CreatorReelsTableBody} from "./reelsTableBody";
import {CreatorReelsTableHeader} from "./reelsTableHeader";
import {CreatorReelsTableSubBody} from "./reelsTableSubBody";


const useStyles = makeStyles(() => ({
  body: {
    position: 'sticky',
    marginBottom: 20
  },
  row: {
    background: '#fff',
  },
  bg: {
      background: '#F2F7FC!important',
  },
  borderRadius10: {
    borderRadius: 10,
    boxShadow: '0px 0px 4px #00000033',
  },
  borderRadiusBottom: {
    borderRadius: '0px 0px 10px 10px'
  },
  card: {
    boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10,
    background:"#fff"
  },
  reelsMaintable:{
    boxShadow: '0px 0px 4px #00000033',
    marginTop:10,
    borderRadius: 10,
  }
}));

function CreatorReelsTable(props: any) {

  const classes = useStyles();
  const [open, setOpen] = useState<number>(-1);
  const { reelsSessions, onOpenReelsSessions } = props;
  const [displayReelsSessions, setDisplayReelsSessions] = useState(false);

  useEffect(() => {
    if (reelsSessions && reelsSessions.length > 0) {
      setDisplayReelsSessions(true)
    }
  }, [reelsSessions]);
  
  const openReelsSessions = (open: any, current_reel: any, sessionIds: any) => {
    setOpen(open);
    
    if (open !== -1)
      onOpenReelsSessions(current_reel, sessionIds);
  };

  const TableExperienceReels = () => {
    return (
      <div className={`${clsx(open === -1) && classes.card } ${classes.reelsMaintable}`}>
        <CreatorReelsTableHeader 
          {...props}
          data={REELS_TABLE_HEADER}
          mainHeader={true}
        />
        <TableContentReels
          {...props}
          open={open}
          setOpen={setOpen}
          openReelsSessions={(open: any, current_reel:any, sessionIds:any) => openReelsSessions(open, current_reel, sessionIds)}
          data={reelsSessions}
        />
      </div>
    )
  };

  return (
    <div className="table">
      {displayReelsSessions ? <TableExperienceReels /> :      
        <Grid container alignItems={'center'} justifyContent={'center'}>
          <Box m={3}>No Reels Available !</Box>
        </Grid>
      }
    </div>
  )
}

export default CreatorReelsTable;

function TableContentReels(props:any) {
  const classes = useStyles();
  const {
    selected, disableNavigation, onChangeSelected, onOpenReelsSessions,  reelsSessions, open, openReelData, openReelId
  } = props;
  const list = reelsSessions;

  const [initialHover, setInitialHover] = useState<any>('');
  return (
    <div className={clsx(classes.body)}>
      {
        list.map((item: any, index: number) =>
          <div key={index}
          className={clsx(
            classes.row,
            item.session_id === open && classes.borderRadius10,
            index === list.length - 1 && classes.borderRadiusBottom,
            (initialHover === item.session_id && open !== item.session_id) && classes.bg
          )}
          onMouseOver={() => setInitialHover(item.session_id)}
          onMouseLeave={() => setInitialHover('')}
          >
            <CreatorReelsTableBody
              HEADER={REELS_TABLE_HEADER}
              item={item}
              initialHover={initialHover}
              {...props}
            />
            {(item.session_id === open && item.session_id === openReelId) && (
              <div style={{ marginBottom: 22, background: '#E4E9EF', borderRadius:"0 0 12px 12px", overflow:"hidden" }} >
                <CreatorReelsTableHeader
                  data={CREATOR_REELS_TABLE_SUBHEADER}
                  sub={true}
                  filter={props.filter}
                  filterDirection={props.filterDirection}
                />

                {(openReelData && openReelData.length > 0) && (
                  openReelData.map((clip: any, k: number) =>
                    <CreatorReelsTableSubBody
                      key={k}
                      HEADER={CREATOR_REELS_TABLE_SUBHEADER}
                      clip={clip}
                      selected={selected}
                      disableNavigation={disableNavigation}
                      onChangeSelected={onChangeSelected}
                      onOpenReelsSessions={onOpenReelsSessions}
                      title={item.session_title}
                      experienceStart={item.start}
                      sessionTrim={item.session_trim_from}
                    />
                  )
                )}
              </div>
            )
            }
          </div>
        )
      }
    </div>
  )

}